import React from "react";
import { Card, CardBody, CardFooter, Image } from "@nextui-org/react";
import { Button } from "@nextui-org/react";
import p from '../p.jpeg'
import pp from '../pp.jpeg'


function Avatar() {

    return (
        <div class="sm:flex-col"style={{height: 'auto',paddingBottom:'200px'}}>

            <div style={{ width: 'auto', paddingTop: '200px', paddingLeft: '50px', paddingRight: '80px' }}>
                <h1 className="font-syne font-[700] text-[50px]" style={{ fontWeight: 800, fontSize: '50px' }}>We are delighted to introduce the NFD team members to you</h1>
                <h2 style={{ fontWeight: 200, fontSize: '25px', paddingTop: '30px' }}>NFD team is always open to new partnerships and new team members, so if you have a desire to join and you have a big experience in development or crypto - just leave your request in form and we will consider it.</h2>
                <br></br>
                <br></br>
                <Button color="primary" variant="shadow" style={{paddingLeft:'30px',paddingRight:'30px',paddingTop:'20px',paddingBottom:'20px'}}>Fill out a from</Button>
            </div>


            <div class="gap-2 grid grid-cols-2 sm:grid-cols-3" style={{ paddingTop: '200px',paddingLeft:'100px',paddingRight:'100px' }}>
                
                    <Card shadow="sm" isPressable style={{maxHeight:'300px', maxWidth:'300px'}}>
                        <CardBody className="overflow-visible p-0">
                            <Image
                                shadow="sm"
                                radius="lg"
                                width="100%"
                                className="w-full object-cover h-[140px]"
                                src={p}
                            />
                        </CardBody>
                        <CardFooter className="text-small justify-between">
                            <b>saurav</b>
                            <p className="text-default-500">CTO</p>
                        </CardFooter>
                    </Card>
                    <Card shadow="sm"  isPressable style={{maxHeight:'300px', maxWidth:'300px'}}>
                        <CardBody className="overflow-visible p-0">
                            <Image
                                shadow="sm"
                                radius="lg"
                                width="100%"
                                
                                className="w-full object-cover h-[140px]"
                                src={pp}
                            />
                        </CardBody>
                        <CardFooter className="text-small justify-between">
                            <b>gaurav</b>
                            <p className="text-default-500">CEO</p>
                        </CardFooter>
                    </Card>
                    <Card shadow="sm"  isPressable style={{maxHeight:'300px', maxWidth:'300px'}}>
                        <CardBody className="overflow-visible p-0">
                            <Image
                                shadow="sm"
                                radius="lg"
                                width="100%"
                                
                                className="w-full object-cover h-[140px]"
                                src={p}
                            />
                        </CardBody>
                        <CardFooter className="text-small justify-between">
                            <b>chaitanya</b>
                            <p className="text-default-500">CCO</p>
                        </CardFooter>
                    </Card>
                    <Card shadow="sm"  isPressable style={{maxHeight:'300px', maxWidth:'300px'}}>
                        <CardBody className="overflow-visible p-0">
                            <Image
                                shadow="sm"
                                radius="lg"
                                width="100%"
                                
                                className="w-full object-cover h-[140px]"
                                src={pp}
                            />
                        </CardBody>
                        <CardFooter className="text-small justify-between">
                            <b>kaushal</b>
                            <p className="text-default-500">Vitale</p>
                        </CardFooter>
                    </Card>
                    <Card shadow="sm"  isPressable style={{maxHeight:'300px', maxWidth:'300px'}}>
                        <CardBody className="overflow-visible p-0">
                            <Image
                                shadow="sm"
                                radius="lg"
                                width="100%"
                                
                                className="w-full object-cover h-[140px]"
                                src={p}
                            />
                        </CardBody>
                        <CardFooter className="text-small justify-between">
                            <b>yash</b>
                            <p className="text-default-500">Frontend</p>
                        </CardFooter>
                    </Card>
                    <Card shadow="sm"  isPressable style={{maxHeight:'300px', maxWidth:'300px'}}>
                        <CardBody className="overflow-visible p-0">
                            <Image
                                shadow="sm"
                                radius="lg"
                                width="100%"
                                
                                className="w-full object-cover h-[140px]"
                                src={pp}
                            />
                        </CardBody>
                        <CardFooter className="text-small justify-between">
                            <b>suru</b>
                            <p className="text-default-500">Backend</p>
                        </CardFooter>
                    </Card>
            
            </div>
        </div>
    )
}

export default Avatar